import React, { Component } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import initReactFastclick from 'react-fastclick';
import CoinStore from 'stores/Coin';
import ExchangeStore from 'stores/Exchange';
import InfoStore from 'stores/Info';

import Exchange from 'scenes/Exchange';
import Pair from 'scenes/Pair';
import NotFound from 'scenes/NotFound';
import Loading from 'scenes/Loading';
import Closed from 'scenes/Closed';

import './styles.css';

const coinStore = new CoinStore();
const exchangeStore = new ExchangeStore();
const infoStore = new InfoStore();

initReactFastclick();

class App extends Component {
  constructor(props) {
    super(props);

    this.onCoinStoreChange = this.onCoinStoreChange.bind(this);
    this.onExchangeStoreChange = this.onExchangeStoreChange.bind(this);
    this.onInfoStoreChange = this.onInfoStoreChange.bind(this);
    this.getCoins = this.getCoins.bind(this);

    this.state = {
      coinStore,
      exchangeStore,
      infoStore,
      error: false,
    };
  }

  componentWillMount() {
    this.getCoins();
  }

  componentDidMount() {
    coinStore.addListener(this.onCoinStoreChange);
    exchangeStore.addListener(this.onExchangeStoreChange);
    infoStore.addListener(this.onInfoStoreChange);
  }

  componentWillUnmount() {
    coinStore.removeListener(this.onCoinStoreChange);
    exchangeStore.removeListener(this.onExchangeStoreChange);
    infoStore.removeListener(this.onInfoStoreChange);
  }

  onCoinStoreChange() {
    this.setState(coinStore);
  }

  onExchangeStoreChange() {
    this.setState(exchangeStore);
  }

  onInfoStoreChange() {
    this.setState(infoStore);
  }

  getCoins() {
    this.state.coinStore.getCoins({}, (error) => {
      if (error) setTimeout(this.getCoins, 5000);
      this.setState({ error });
    });
  }

  render() {
    return (
      <div className="app">
        <Closed />
      </div>
    );
  }

  // render() {
  //   return (
  //     <div className="app">
  //       {this.state.error ?
  //         <div className="app__error">{this.state.error}</div>
  //       : null}
  //
  //       {this.state.coinStore.loaded ?
  //         <Switch>
  //           <Route
  //             path="/exchange/:uuid([0-9a-f]{8}[0-9a-f]{4}4[0-9a-f]{3}[89ab][0-9a-f]{3}[0-9a-f]{12})"
  //             render={props => (
  //               <Exchange
  //                 {...props}
  //                 infoStore={this.state.infoStore}
  //                 exchangeStore={this.state.exchangeStore}
  //                 coinStore={this.state.coinStore}
  //               />
  //             )}
  //           />
  //           <Route
  //             path="/:pair([0-9a-z]+_[0-9a-z]+)"
  //             render={props => (
  //               <Pair
  //                 {...props}
  //                 infoStore={this.state.infoStore}
  //                 exchangeStore={this.state.exchangeStore}
  //                 coinStore={this.state.coinStore}
  //               />
  //             )}
  //           />
  //           <Route
  //             exact
  //             path="/:from([0-9a-z]+_?)"
  //             render={(props) => {
  //               const fromSymbol = props.match.params.from.replace('_', '').toUpperCase();
  //               const firstCoin = this.state.coinStore.coins[0];
  //               const secondCoin = this.state.coinStore.coins[1];
  //
  //               let toCoin = firstCoin;
  //               if (fromSymbol === firstCoin.symbol) toCoin = secondCoin;
  //
  //               return (
  //                 <Redirect to={`/${fromSymbol}_${toCoin.symbol}`} />
  //               );
  //             }}
  //           />
  //           <Route
  //             exact
  //             path="/"
  //             render={() => (
  //               <Redirect to={`/${this.state.coinStore.coins[0].symbol}_${this.state.coinStore.coins[1].symbol}`} />
  //             )}
  //           />
  //           <Route component={NotFound} />
  //         </Switch>
  //       : <Loading />}
  //     </div>
  //   );
  // }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.jsx